import { themeHelpers } from '@gotamedia/fluffy';
import styled, { css } from 'styled-components';
const Flex = styled.div.withConfig({
  displayName: "style__Flex",
  componentId: "sc-gb4qxt-0"
})(["display:flex;padding:20px;flex-direction:column;&:first-child{flex:2;}&:last-child{flex:1;}", ""], themeHelpers.isSmallDevice(css(["flex-direction:column;padding-bottom:0;"])));
const FlexRow = styled.div.withConfig({
  displayName: "style__FlexRow",
  componentId: "sc-gb4qxt-1"
})(["display:flex;flex-direction:row;", ""], themeHelpers.isSmallDevice(css(["flex-direction:column;"])));
const Text = styled.p.withConfig({
  displayName: "style__Text",
  componentId: "sc-gb4qxt-2"
})(["font-family:'Sanomat Sans Text';font-weight:400;font-size:14px;line-height:18px;white-space:pre-line;color:", ";"], ({
  theme
}) => theme.colors.grey[3]);
const Headline = styled.h2.withConfig({
  displayName: "style__Headline",
  componentId: "sc-gb4qxt-3"
})(["font-family:'Sanomat Sans Text';font-weight:700;font-size:14px;line-height:18px;white-space:pre-line;color:", ";"], ({
  theme
}) => theme.colors.grey[4]);
const Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-gb4qxt-4"
})(["display:flex;margin-bottom:10px;flex-direction:column;&:first-child{flex:2;}&:last-child{flex:1;}p,h2{white-space:pre-line;margin-bottom:5px;}"]);
export { Text, Headline, FlexRow, Flex, Wrapper };